/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockRecipeEditCtrl
 */
angular.module('mercury.modules.stock.recipe')
.controller('StockRecipeEditCtrl', ["dialog", "$scope", "$uibModal", "$q", "$state", "$stateParams", "StockCost", "StockItems", "StockRecipes", "StockUnits", "$timeout", "title", "$window", function(dialog, $scope, $uibModal, $q, $state, $stateParams, StockCost,
  StockItems, StockRecipes, StockUnits, $timeout, title, $window) {

  $scope.recipeChanged = false;
  // The true here includes deleted units. We need these as it is possible for a stock item's unit to be a deleted unit. 
  // See the addNewLine method
  $scope.allUnits = StockUnits.getAllStockApi(true);
  var stockItems = StockItems.getAllStockApi();
  var allRecipes = StockRecipes.getAllStockApi();

  if (window.frameElement === null) {
    $scope.isPrinting = false;
  }

  $scope.selectedVersionIndex = '0';
  var currentVersionIndex = 0;
  var modalInstance;

  window.onafterprint = function() {
    $('.print-spinner', window.parent.document).removeClass('open');
    $('.print-embed', window.parent.document).remove();
  };

  $scope.withinDialog = $stateParams.withinDialog || false;

  if ($stateParams.id) {
    $scope.recipeLoading = StockRecipes.getStockApi($stateParams.id)
    .then(function(result) {
      var pageTitle = 'Manage ' + result.name;
      $scope.title = pageTitle;
      if (!$scope.withinDialog) {
        title.set(pageTitle);
      }

      var itemsToCost = [];
      var recipesToCost = [];

      $scope.recipe = result;

      var nowTimeString = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ')
      if ($scope.recipe.versions.length > 1) {
        // If there are multiple versions:
        //   1. Find the current version 
        //   2. Add the each line stock (recipe or item) to a array that will retreive their current cost
        angular.forEach($scope.recipe.versions, function(version, versionIndex) {
          if (version.validFrom === null || moment(version.validFrom).isBefore()) {
            currentVersionIndex = versionIndex;
          }
          version.lines.forEach(line => {
            addDataToStockCostArray(line, nowTimeString, itemsToCost, recipesToCost);
          })
        });
      } else {
        // If there is only one version, add the stock to appropiate arrays for costing
        $scope.recipe.versions[0].lines.forEach(line => {
          addDataToStockCostArray(line, nowTimeString, itemsToCost, recipesToCost);
        })
      }
      // Get the current cost of the stock within the recipe
      $scope.stockCostPromise = StockCost.get(itemsToCost, recipesToCost)
        .then((result) => {
          $scope.stockCosts = result
        });

      $scope.selectedVersionIndex = currentVersionIndex.toString();
      $scope.version = result.versions[currentVersionIndex];

      var nextVersionIndex = parseInt($scope.selectedVersionIndex, 10) + 1;
      if (result.versions[nextVersionIndex]) {
        $scope.validUntil = result.versions[nextVersionIndex].validFrom;
      }
    });

    $scope.loadingPromises = [
      $scope.allUnits.$promise,
      stockItems.$promise,
      allRecipes.$promise,
      $scope.recipeLoading,
      $scope.stockCostPromise
    ];
  } else {
    title.set('Create Recipe');

    $scope.recipe = {
      imagesJson: []
    };
    $scope.version = {
      yieldQuantity: 1,
      yieldUnitRatio: 1,
      yieldUnitId: null,
      yieldUnitName: '',
      versionNo: 1,
      lines: []
    };

    $scope.loadingPromises = [
      $scope.allUnits.$promise,
      stockItems.$promise,
      allRecipes.$promise
    ];
  }

  $q.all($scope.loadingPromises)
  .then(function() {
    // set $scope.units as all active units so a user cannot select a deleted unit
    $scope.units = $scope.allUnits.filter(u => u.datestampDeleted == null);

    var queryString = window.location.hash;
    if (queryString.includes('?print')) {
      // When printing the recipe we need to wait for the stock costs requests to be completed 
      // otherwise cost columns will be blank
      $scope.stockCostPromise.then(function() {
        // We need to use $timeout here to ensure that the Angular digest cycle
        // triggered from the promise chain completing and the loader being
        // removed has been fully 'digested' (a.k.a the DOM is finshed updating)
        // before we trigger the print call. There are some Angular events that
        // are supposed to signify rendering completed but they're not accurate
        // and end up firing when the loader is displayed - the end result being
        // a grey box shown on the printout.
        $timeout(function() {
          $window.print();
        });
      })
    }

  })
  .catch(function() {
    $state.go('Stock.Recipe');
  });

  $scope.print = function() {
    $window.print();
  };

  $scope.newPrint = function() {
    jQuery('.print-spinner').addClass('open');

    $('<iframe class="print-embed">')                             // create a new iframe element
    .css({'width': '1px', 'height': '1px', 'opacity': '0'})                            // make it invisible
    .attr('src', '/App/#/stock/recipes/view/' + $scope.recipe.id + '?print=true') // point the iframe to the page you want to print
    .appendTo('body');

  };

  /**
   * Adds the the line's item or recipe to the relvant array to get costed
   * @param {*} line the line holding an stock item or recipe
   * @param {*} timeString the time to cost the item/recipe at
   * @param {*} itemsToCost An array of items to be costed
   * @param {*} recipesToCost An array of recipe to be costed
   */
  var addDataToStockCostArray = (line, timeString, itemsToCost, recipesToCost) => {
    if (line.itemId) {
      var itemIdTimeString = `${line.itemId},${timeString}`
      if (!itemsToCost.includes(itemIdTimeString)) itemsToCost.push(itemIdTimeString);
      return
    }

    var recipeIdTimeString = `${line.recipeId},${timeString}`
    if (!recipesToCost.includes(recipeIdTimeString)) recipesToCost.push(recipeIdTimeString);
  }

  /**
   * Extracts the stock cost of recipe line
   * @param {*} line the recipe line
   * @returns The stock cost of the recipe line
   */
  $scope.getStockCost = function(line) {
    var stockCost = line.itemId 
      ? $scope.stockCosts.itemCosts[line.itemId][0]
      : $scope.stockCosts.recipeCosts[line.recipeId][0]
    
    return stockCost.cost
  }

  /**
   * Checks whether a promise is pending
   * @param {*} promise the promise to check
   * @returns true if the promise is pending false if not
   */
  $scope.promiseIsPending = function(promise) {
    return promise && promise.$$state.status == 0;
  };

  /**
   * Checks wehther all promises within an array are resolved
   * @param {*} array the array of items holding objects
   * @param {*} attributeName the attribute to check within the object
   * @returns true if all promises are resolved, false if not 
   */
  $scope.allPromisesFinished = function(array, attributeName) {
    if (!array) return true;
    for (var i = 0; i < array.length; i++) {
      if ($scope.promiseIsPending(array[i][attributeName])) {
        return false;
      }
    }
    return true;
  };

  /**
  * Get all the Recipes and Items that are valid Recipe Lines. This excludes ones already used in recipe lines.
  *
  * @return {Array} List of options to be used in the add recipe line input autocomplete.
  */
  $scope.newLineOptions = function() {
    var existingItems = {items: {}, recipes: {}};
    angular.forEach($scope.version.lines, function(recipeLine) {
      if (recipeLine.itemId) {
        existingItems.items[recipeLine.itemId] = true;
      } else if (recipeLine.recipeId) {
        existingItems.recipes[recipeLine.recipeId] = true;
      }
    });

    var options = [];

    angular.forEach(stockItems, function(stockItem) {
      if (existingItems.items[stockItem.id]) {
        return;
      }

      options.push({
        name: stockItem.name,
        category: stockItem.groupName,
        value: stockItem,
        isRecipe: false
      });
    });

    angular.forEach(allRecipes, function(recipe) {
      if (existingItems.recipes[recipe.id] || recipe.id == $scope.recipe.id) {
        return;
      }

      options.push({
        name: recipe.name,
        category: 'Recipe',
        value: recipe,
        isRecipe: true
      });
    });

    return options;
  };

  /**
  * Callback for changing the Yeild Unit. Update the ratio and recalculate the quantity
  *
  * @param {Object} newUnit The selected unit from the autocomplete box
  */
  $scope.yieldUnitChanged = function(newUnit) {
    // Update the stored quantity (BaseUnits) so once the ratio is updated, the displayed quantity won't change.
    if ($scope.version.yieldQuantity) {
      $scope.version.yieldQuantity = ($scope.version.yieldQuantity / $scope.version.yieldUnitRatio) * newUnit.ratio;
    }
    $scope.version.yieldUnitRatio = newUnit.ratio;
  };

  /**
  * Callback for changing the Unit of a recipe line. Update the ratio and recalculate the quantity
  *
  * @param {Number} index The index of the line being updated
  * @param {Object} newUnit The selected unit from the autocomplete box
  */
  $scope.lineUnitChanged = function(index, newUnit) {
    // Update the stored quantity (BaseUnits) so once the ratio is updated, the displayed quantity won't change.
    var line = $scope.version.lines[index];
    if (line.quantity) {
      line.quantity = (line.quantity / line.unitRatio) * newUnit.ratio;
    }
    line.unitRatio = newUnit.ratio;
  };

  /**
  * Return the version string based on the index of the version
  *
  * @param {Number} index
  * @return {String} The resulting version string
  */
  $scope.formatVersion = function(index) {
    if (index == currentVersionIndex) {
      return 'CURRENT';
    } else {
      return parseInt(index, 10) + 1;
    }
  };

  /**
  * Check if any of the recipes lines in the displayed version has a deleted object
  *
  * @return {Boolean} If a deleted object exists, return true, otherwise false.
  */
  $scope.versionHasDeletedLines = function() {
    var result = false;
    if ($scope.version) {
      angular.forEach($scope.version.lines, function(line) {
        if (line.stockDeletedAt) {
          result = true;
        }
      });
    }
    return result;
  };

  /**
  * Callback for selecting a new version from the version selector. Fetch the full
  * model for the selected version from the server.
  */
  $scope.versionChange = function() {
    var selectedIndex = parseInt($scope.selectedVersionIndex, 10);

    $scope.version = $scope.recipe.versions[selectedIndex];
    var nextVersionIndex = selectedIndex + 1;
    $scope.validUntil = ($scope.recipe.versions[nextVersionIndex]) ? $scope.recipe.versions[nextVersionIndex].validFrom : null;
  };

  /**
  * Remove the specified line from the recipe version
  *
  * @param {Number} lineIndex
  */
  $scope.removeLine = function(lineIndex) {
    $scope.version.lines.splice(lineIndex, 1);

    $scope.recipeEditForm.newRecipeLine.$setValidity('haslines', $scope.version.lines.length > 0);
  };

  /**
  * Add a new line to the recipe version based on the selected StockItem or Recipe
  *
  * @param {Object} selectedOption The Recipe or StockItem that was selected
  */
  $scope.addNewLine = function(selectedOption) {
    $scope.recipeEditForm.newRecipeLine.$setValidity('haslines', true);

    if (selectedOption.isRecipe) {
      $scope.version.lines.push({
        quantity: 1 * selectedOption.value.currentVersion.yieldUnitRatio,
        recipeId: selectedOption.value.id,
        recipeName: selectedOption.value.name,
        unitName: selectedOption.value.currentVersion.yieldUnitName,
        unitId: selectedOption.value.currentVersion.yieldUnitId,
        unitRatio: selectedOption.value.currentVersion.yieldUnitRatio,
        stockUnitName: selectedOption.value.currentVersion.yieldUnitName,
        stockUnitRatio: selectedOption.value.currentVersion.yieldUnitRatio,
        currentPricePromise: getCurrentPriceOfNewLine(selectedOption.value.id, 'recipe')
      });
    } else {
      var orderingUnit = $scope.allUnits.find(u => u.id === selectedOption.value.orderingUnitId)
      $scope.version.lines.push({
        quantity: 1 * orderingUnit.ratio,
        itemId: selectedOption.value.id,
        itemName: selectedOption.value.name,
        unitName: orderingUnit.name,
        unitId: orderingUnit.id,
        unitRatio: orderingUnit.ratio,
        stockUnitName: orderingUnit.name,
        stockUnitRatio: orderingUnit.ratio,
        currentPricePromise: getCurrentPriceOfNewLine(selectedOption.value.id, 'item')
      });
    }

    if ($scope.recipe.isShared) {
      dialog.alert(selectedOption.value.name + ' will be automatically shared to all companies that use this recipe.');
    }
  };

  /**
   * Checks if there stock id is already in the stock cost object, make a request if not.
   * @param {*} newLineStockId the stock item or recipe id
   * @param {*} recipeOrItem whether the ID represents an item or recipe
   * @returns undefined if the stock is already in stock cost object, a promise if not.
   */
  var getCurrentPriceOfNewLine = (newLineStockId, recipeOrItem) => {
    // If this is a recipe with no line (a newly created recipe) the stockCosts object will not be populated 
    if (!$scope.stockCosts) {
      if (recipeOrItem == 'recipe') {
        return StockCost.get([],[newLineStockId]).then(result => addNewStockCost(result));
      }
      return StockCost.get([newLineStockId],[]).then(result => addNewStockCost(result));
    }

    if (recipeOrItem === 'recipe') {
      return $scope.stockCosts[newLineStockId] 
      ? undefined
      : StockCost.get([], [`${newLineStockId},${moment().format()}`])
        .then(result => addNewStockCost(result))
    }

    return $scope.stockCosts[newLineStockId] 
      ? undefined
      : StockCost.get([`${newLineStockId},${moment().format()}`], [])
        .then(result => addNewStockCost(result))
  }

  /**
   * Adds new StockCosts to the $scope.StockCosts object
   * @param {*} newStockCostResponse a new StockCostResponse
   */
  var addNewStockCost = (newStockCostResponse) => {    
    // If the recipe has no lines then the stockCosts object will be undefined
    if ($scope.stockCosts == undefined){
      $scope.stockCosts = newStockCostResponse;
      return;
    }

    for (recipeId of Object.keys(newStockCostResponse.recipeCosts)) {
      // Purposely overwrite the stock cost if the recipe already exists in the object 
      // This is beacse we only use current time as the costed at time (for this page) so
      // It will just be a more up to date cost.
      $scope.stockCosts.recipeCosts[recipeId] = newStockCostResponse.recipeCosts[recipeId]
    }

    for (itemId of Object.keys(newStockCostResponse.itemCosts)) {
      // Purposely overwrite the stock cost if the item already exists in the object 
      // This is beacse we only use current time as the costed at time (for this page) so
      // it will just be a more up to date cost.
      $scope.stockCosts.itemCosts[itemId] = newStockCostResponse.itemCosts[itemId]
    }
  }

  /**
  * Save the current recipe and version model to the server.
  */
  $scope.updateRecipe = function() {
    $scope.recipeEditForm.newRecipeLine.$setValidity('haslines', $scope.version.lines.length > 0);

    $scope.recipeEditForm.$setSubmitted();
    if ($scope.recipeEditForm.$invalid) {
      return;
    }

    StockRecipes.save($scope.recipe, $scope.version, $scope.validUntil)
    .then(function() {
      if ($scope.withinDialog === true) {
        $scope.recipeChanged = true;
        $scope.close();
      } else {
        $state.go('Stock.Recipe');
      }
    }, function(response) {
      if (response.data && response.data.modelState) {
        $scope.modelState = response.data.modelState;
      }
    });
  };

  /**
  * Open the 'Save as New Version' dialog
  */
  $scope.saveNewVersion = function() {
    $scope.recipeEditForm.newRecipeLine.$setValidity('haslines', $scope.version.lines.length > 0);

    $scope.recipeEditForm.$setSubmitted();
    if ($scope.recipeEditForm.$invalid) {
      return;
    }

    var lastValidFrom = $scope.recipe.versions[$scope.recipe.versions.length - 1].validFrom;
    if (lastValidFrom === null || moment(lastValidFrom).isBefore()) {
      $scope.newVersionValidFrom = moment().startOf('day').format();
    } else {
      $scope.newVersionValidFrom = moment(lastValidFrom).add(1, 'day').format();
    }

    modalInstance = $uibModal.open({
      templateUrl: 'modules/stock/recipe/newversion.tpl.html',
      scope: $scope
    });
  };

  /**
  * Confirm the Save as New version date and create the new version on the server
  *
  * @param {String} validFromDate ISO date for when the new version should be valid from
  * @param {Object} newVersionForm FormCtrl of the new version form.
  */
  $scope.saveNewVersionConfirm = function(validFromDate, newVersionForm) {
    newVersionForm.$setSubmitted();

    var versionCopy = angular.copy($scope.version);

    delete versionCopy.id;
    versionCopy.validFrom = validFromDate;

    $scope.savingNewVersion = StockRecipes.save($scope.recipe, versionCopy);
    $scope.savingNewVersion.then(function() {
      modalInstance.close();
      if ($scope.withinDialog === true) {
        $scope.recipeChanged = true;
        $scope.close();
      } else {
        $state.go('Stock.Recipe');
      }
    }, function(response) {
      if (response.data && response.data.modelState) {
        $scope.newVersionModelState = response.data.modelState;
      }
    });
  };

  /**
  * Calculate the total cost of the recipe lines.
  *
  * @return {Number} The total cost
  */
  $scope.totalCost = function() {
    if (!$scope.version) {
      return 0;
    }

    var total = 0;
    angular.forEach($scope.version.lines, function(line) {
      if (line.quantity) {
        total += $scope.getStockCost(line) * line.quantity;
      }
    });
    return total;
  };

  /**
  * Callback for clicking the 'Add Image' button of the instructions
  * This function is called from within the testangular.config.js file
  */
  $scope.openNoteImageDialog = function() {
    var deferred = $q.defer();

    $uibModal.open({
      templateUrl: 'modules/stock/recipe/imagemanage.tpl.html',
      controller: 'StockRecipeImagemanageCtrl',
      size: 'lg',
      resolve: {
        recipe: function() {
          return $scope.recipe;
        },
        onAdd: function() {
          return function(images) {
            $scope.recipe.imagesJson = images;
          };
        },
        onSelect: function() {
          return function(image) {
            deferred.resolve(image);
          };
        },
        onDelete: function() {
          return function(deletedImage) {
            if ($scope.recipe.mainImageJson && $scope.recipe.mainImageJson.id == deletedImage.id) {
              $scope.recipe.mainImageJson = null;
            }
          };
        }
      }
    });

    return deferred.promise;
  };

  /**
   * Click event for clicking the main image, open the image manage dialog.
   */
  $scope.openMainImageDialog = function() {
    $uibModal.open({
      templateUrl: 'modules/stock/recipe/imagemanage.tpl.html',
      controller: 'StockRecipeImagemanageCtrl',
      size: 'lg',
      resolve: {
        recipe: function() {
          return $scope.recipe;
        },
        onAdd: function() {
          return function(images) {
            $scope.recipe.imagesJson = images;
          };
        },
        onSelect: function() {
          return function(image) {
            $scope.recipe.mainImageJson = image;
          };
        },
        onDelete: function() {
          return function(deletedImage) {
            if ($scope.recipe.mainImageJson && $scope.recipe.mainImageJson.id == deletedImage.id) {
              $scope.recipe.mainImageJson = null;
            }
          };
        }
      }
    });
  };

  $scope.openSubRecipeDialog = function(recipeId) {
    dialog.open({
      backdrop: 'static',
      templateUrl: 'modules/stock/recipe/edit.tpl.html',
      controller: 'StockRecipeEditCtrl',
      size: 'lg',
      resolve: {
        $stateParams: function() {
          return {
            id: recipeId,
            withinDialog: true
          };
        }
      }
    }).then(function(dialogResult) {
      if (dialogResult && dialogResult.recipeChanged === true) {
        $scope.recipeChanged = true;
      }
    });
  };

  /**
  * Delete the selected version from the database.
  */
  $scope.deleteVersion = function() {
    StockRecipes.removeVersion($scope.version)
    .then(function() {
      if ($scope.withinDialog === true) {
        $scope.close();
      } else {
        $state.go('Stock.Recipe');
      }
    });
  };

  $scope.close = function() {
    if ($scope.withinDialog === true) {
      dialog.close({recipeChanged: $scope.recipeChanged});
    } else {
      $state.go('Stock.Recipe');
    }
  };
}]);
